import { FC, ReactNode, useState } from 'react';
import { NavLink as RouterLink } from 'react-router-dom';

import { Button, Badge, Collapse, ListItem } from '@mui/material';

import ExpandLessTwoToneIcon from '@mui/icons-material/ExpandLessTwoTone';
import ExpandMoreTwoToneIcon from '@mui/icons-material/ExpandMoreTwoTone';

interface SidebarMenuItemProps {
  children?: ReactNode;
  link?: string;
  icon?: any;
  badge?: string;
  open?: boolean;
  active?: boolean;
  name: string;
  id: number;
}

const SidebarMenuItem: FC<SidebarMenuItemProps> = ({
  children,
  link,
  icon: Icon,
  badge,
  open: openParent,
  active,
  name,
  id,
  ...rest
}) => {
  const [menuToggle, setMenuToggle] = useState<boolean>(openParent);

  const toggleMenu = (): void => {
    setMenuToggle((Open) => !Open);
  };

  // const { toggleSidebar } = useContext(SidebarContext);

  if (children) {
    return (
      <ListItem component="div" className="Mui-children" key={id.toString()} {...rest}>
        <Button
          className={menuToggle ? 'MuiParent-active' : ""}
          startIcon={Icon && <Icon />}
          endIcon={
            menuToggle ? <ExpandLessTwoToneIcon /> : <ExpandMoreTwoToneIcon />
          }
          onClick={toggleMenu}
        >
          {name}
        </Button>
        <Collapse in={menuToggle} sx={{ paddingLeft: 2 }}>{children}</Collapse>
      </ListItem>
    );
  }
  return (
    <ListItem component="div" key={id.toString()} {...rest}>
      <Button
        className={active ? 'Mui-active' : ""}
        component={RouterLink}
        // onClick={toggleSidebar}
        to={link}
        startIcon={Icon && <Icon />}
      >
        {name}
        {badge && <Badge badgeContent={badge} />}
      </Button>
    </ListItem>
  );
};

SidebarMenuItem.defaultProps = {
  open: false,
  active: false
};

export default SidebarMenuItem;
